import styled from 'styled-components'
import OverflowBox from 'Layout/OverflowBox'

export const _AppLineChartContainer = styled(OverflowBox)`
  width: 100%;
  height: ${({ forPrint }) => (forPrint ? '185' : '370')}px;
  overflow-x: auto;
  overflow-y: hidden;
  box-sizing: border-box;

  .recharts-cartesian-axis-line {
    stroke: transparent;
  }
  .recharts-cartesian-axis-tick-line {
    stroke: transparent;
  }
  .recharts-yAxis .recharts-cartesian-axis-ticks {
    g:first-child {
      display: none;
    }
  }
  .recharts-cartesian-grid-horizontal, .recharts-cartesian-grid-vertical {
    > {
      :first-child {
        stroke-dasharray: none;
      }
      :last-child {
        stroke-dasharray: none;
      }
    }

  }
  ${({ forPrint }) => (!forPrint && `
    @media screen and (max-width: 700px) {
      &::-webkit-scrollbar {
        display: block;
        height: 11px;
        -webkit-border-radius: 0;
        border-radius:0;
      }
    }
  `)};
`
